// extracted by mini-css-extract-plugin
export default {"navitem":"navitem_aab88c5e24eba08b8519","icon":"icon_a2877d428dbcffa05dbb","popupmsg":"popupmsg_c018c2e4dd212ad05aec"};